import React from 'react';

const LoadingPage = () => {
  return (
    <div />
  );
};

export default LoadingPage;
